<div class="position-relative w-100 padding">
    <router-outlet></router-outlet>
</div>